import bgPattern from '@/assets/images/BG Pattern.webp';

import styles from './overlay-chrome.module.scss';

/** Decorative texture strip used in overlay headers and dialog tops. */
export function OverlayPattern({ className }: { className?: string }) {
  return (
    <img
      src={bgPattern}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={[styles.pattern, className].filter(Boolean).join(' ')}
    />
  );
}
